<script>

import Popper from "vue3-popper";
import { useToast } from "vue-toastification";
 /* Default icons are required for TinyMCE 5.3 or above */
 import 'tinymce/icons/default';

 /* A theme is also required */
 import 'tinymce/themes/silver';

 /* Import the skin */
 import 'tinymce/skins/ui/oxide/skin.css';

 /* Import plugins */
 import 'tinymce/plugins/advlist';
 import 'tinymce/plugins/code';
 import 'tinymce/plugins/emoticons';
 import 'tinymce/plugins/emoticons/js/emojis';
 import 'tinymce/plugins/link';
 import 'tinymce/plugins/lists';
 import 'tinymce/plugins/table';


//components
import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getStateOptions } from '@/services/serviceCommon';
import { getAccessRightsOptions } from '@/services/serviceAccessRight';
import { getContact, unlockContact, saveContact, createContact } from '@/services/mailing/serviceContact';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'ContactEdit',
	mixins: [ MixinGeneralFunct ],
	components: {
		Popper
		,LoadingScreen
		,LoadingButton
	},
	props: {'contactId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["contactId","changeRecord"],
	data() {
	
		return {
			metaData: [],
			
			isLoading:true,
			isSending:false,
			
			optionsAccessLevels: [],
			optionsTypes:[],
			optionsCategories:[],
			optionsStates:[],
			optionsLanguages:[],
			
			initObj: {
				
				relative_urls: false
				,convert_urls: false
				,remove_script_host:false
				,height:450
				,entity_encoding : "raw" 
				,language:'sk'
				,extended_valid_elements: 'i[class]'
				,iconfonts_selector: '.fa, .fab, .fal, .far, .fas, .glyphicon'
			},
			
						
			//form
			data:[],

			//tabs
			tab1:'',
			tab2:'',
			
		}
	},
	
	mounted:function(){
		this.tab1 = `tab${this.getRandomInt(99999999999)}`;
		this.tab2 = `tab${this.getRandomInt(99999999999)}`;
	},
	
	methods: {
		// load data form
		loadDefaultValues:function(){

			this.isLoading=true

			getContact({contactId:this.contactId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.metaData = response.metaData;
					this.data = response.data;
					this.optionsCategories = response.optionsCategories;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getAccessRightsOptions().then(response => {
				if(!response.statusText){
					this.optionsAccessLevels = response.optionsAccessLevels;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getStateOptions().then(response => {
				if(!response.statusText){
					this.optionsStates = response.optionsStates;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
			
		
		},
				
		checkSave:function(){
								
			if(!this.data.email){this.data.emailError = true; }else{this.data.emailError = false;}
			if(!this.data.access){this.data.accessError = true; }else{this.data.accessError = false;}
			
			if(!this.data.emailError && this.data.access){
				return true;
			}else{
				return false;
			}
		},	
		


		onSave:function(){
							
			if(this.checkSave()){
				if(this.contactId!='null'){	
					this.isSending=true
					saveContact({data:this.data,optionsCategories:this.optionsCategories}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}else{
					createContact({data:this.data,optionsCategories:this.optionsCategories}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}	
			}
			
		},

				
		onClose:function(){
			if(this.contactId!='null'){
				unlockContact(this.contactId).then(response => {
					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},

	},
	
	watch: {
		contactId() {
			this.loadDefaultValues();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>

		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-lg modal-dialog-scrollable">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCore.Contact') }} <span v-if="!data.isNewRecord"><b>{{ data.title }}</b> id: {{data.id}}</span></h6>
					</div>
			
							<div v-if="metaData.modulAccess && (auth.contactsNew || auth.contactsEdit)" class="modal-body">
								
								<div class="row">
									<div class="col-12">
										<div v-if="data.isCheckedOut && secData.userId != data.isCheckedOutId" class="angle">
											<span class="angle-inner" :class="{'angle-warning':data.isCheckedOut}"><i class="fa" :class="{'angle-warning':data.isCheckedOut, 'fa-exclamation-triangle':data.isCheckedOut}" aria-hidden="true"></i> {{$t('msgCore.Edited')}} </span >
											
											<Popper v-if="data.isCheckedOut" :content="data.isCheckedOutName+', '+data.isCheckedOutDate">
												<button class="personCircle v-center" v-bind:style="{background:data.isCheckedOutColor}">{{ data.isCheckedOutLetterName+''+data.isCheckedOutLetterSurname }}</button>
											</Popper>
											
										</div>
									</div>
								</div>
							
								<div class="row">
									
									<div class="col-md-8 col-12">
								
										<ul class="nav nav-tabs" role="tablist">
							
											<li class="nav-item" role="presentation">
												<a class="nav-link active" :id="`${tab1}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab1}`" role="tab" :aria-controls="tab1" aria-selected="true">{{ $t('msgCore.basicData') }}</a>
											</li>
											
											<li class="nav-item" role="presentation">
												<a class="nav-link" :id="`${tab2}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab2}`" role="tab" :aria-controls="tab2" aria-selected="false">Kategórie</a>
											</li>
											
										</ul>

										<div class="tab-content" id="myTabContent">
								
											<div :id="`${tab1}`" class="tab-pane active" role="tabpanel" :aria-labelledby="`${tab1}-tab`">
															
									
												<div class="form-row">
																								
													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Firstname') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.firstname" >
														
													</div>
													
													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Surname') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.surname" >
														
													</div>
												</div>

												<div class="form-row">
													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Mobil') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.mobil" >
														
													</div>

													<div class="form-group col-md-4 col-12">
														<label :class="{'text-danger':data.emailError}"><b>{{ $t('msgCore.Email') }}</b> </label>
														<input type="text" class="form-control form-control-sm" :class="{'is-invalid':data.emailError}" v-on:change="checkSave()" v-model="data.email" >
														<div v-show="data.emailError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
													</div>
												
												</div>

												<div class="form-row">
													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Mobil') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.mobil2" >
													</div>

													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Email') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.email2" >
													</div>
												</div>

												<div class="form-row">
													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Mobil') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.mobil3" >
													</div>

													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Email') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.email3" >
													</div>
												</div>

												<div class="form-row">
													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Mobil') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.mobil4" >
													</div>

													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Email') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.email4" >
													</div>
												</div>

												<div class="form-row">
													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Mobil') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.mobil5" >
													</div>

													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Email') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.email5" >
													</div>
												</div>


												
												<div class="form-row">
													
													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Company') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.company" >
														
													</div>

													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Ico') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.ico" >
														
													</div>
												
												</div>	

												<div class="form-row">
													
													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.City') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.city" >
														
													</div>

													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Street') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.street" >
														
													</div>

													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.PSC') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.psc" >
														
													</div>
												
												</div>	

												<div class="form-row">
													
													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Web') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.web" >
														
													</div>

													<div class="form-group col-md-4 col-12">
														<label ><b>{{ $t('msgCore.Address') }}</b> </label>
														<input type="text" class="form-control form-control-sm" v-model="data.address" >
														
													</div>

												</div>	

											</div>

											<div :id="`${tab2}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab2}-tab`">
												<div class="form-row">	
													<div class="col-12" >
														<label><b>Výber kategórie</b> </label>
														<div  v-for="(item) in optionsCategories" :key="item" class="togglebutton">
															<label>
															<input v-model='item.isSelected' type="checkbox">
															<span class="toggle"></span>
															{{item.title}}
															</label>
														</div>
													</div>
												</div>
											</div>
											
											
											
											
												
										</div>
										
									</div>
									
									<div class="col-md-4 col-12 form-control-system-data">
											
										<div class="form-row">
										
											<div class="form-group col-12">
												<label :class="{'text-danger':data.accessError}"><b>{{ $t('msgCore.AccessLevel') }}</b></label>
																									
												<select v-model='data.access' class="form-control form-control-sm " :class="{'is-invalid':data.accessError}" v-on:change="checkSave()">
													<option value="">{{ $t('msgCore.selectLevel') }}</option>
													<option v-for="(option) in optionsAccessLevels" :value="option.value" :key="option">{{ option.title }}</option>
												</select>
												<div v-show="data.accessError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectLevel')}}</span></div>
											</div>
											
											<div class="form-group col-12">
												<label :class="{'text-danger':data.stateError}"><b>{{ $t('msgCore.State') }}</b></label>
												
												<div  v-for="(option) in optionsStates" :key="option.value" class="form-check">
													<label class="form-check-label">
														<input class="form-check-input" type="radio" name="optionsStates"  v-model='data.state' v-on:change="checkSave()" :value="option.value">
														{{ $t('msgCore.'+option.title) }}
														<span class="circle">
															<span class="check"></span>
														</span>
													</label>
												</div>
												<div v-show="data.stateError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectState')}}</span></div>
											</div>
											
											
										
										</div>
										
									</div>										
																		
								</div>
								
							</div>
							
							<div v-else class="modal-body">
								<div class="row">
									<div class="col-12">
										<div class="alert alert-warning" role="alert">
											{{$t('msgCore.accessDenied')}}
										</div>
									</div>
								</div>
							</div>
							
							<div class="modal-footer">
							
								<div class="btn-group">
									<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
									
									
									<LoadingButton :isDisabled="(!auth.contactsEdit || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onSave" :label="'msgCore.btnSave'" color="warning"></LoadingButton>
								</div>	
								
							</div>
						
				
					
					
				
				</div>

			</div>
			
		</div>
		

	</div>
	

</template>


